module.exports = __webpack_public_path__ + "static/media/inbox_l.a01af3f3.svg";